export const texts = {
  matches: {
    de: 'Passende Talente',
    en: 'Matching talents'
  },
  switchSignals: {
    de: 'mit Wechselsignal',
    en: 'With switch signal'
  },
  contacted: {
    de: 'Bereits kontaktiert',
    en: 'Already contacted'
  },
  matchingTalents: {
    de: 'Passende Talente',
    en: 'Matching talents'
  },
  mustHavesMet: {
    de: 'Must-haves',
    en: 'must-haves'
  },
  notMet: {
    de: 'nicht erfüllt',
    en: 'not met'
  },
  switchSignal: {
    de: 'Wechselsignal',
    en: 'Switch signal'
  }
};
